import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { CenterArrivalDepartureTransfer } from '../../../lib/types/models/center/center-arrival-departure-transfers'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterArrivalDepartureTransfers(id: number, query: PaginationRequest = {}) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.centers.getCenterArrivalDepartureTransfers.url, { id }),
        query
      )
    )
    .get<PaginationResponse<CenterArrivalDepartureTransfer>>()
}
